import precedaService from '../services/precedaService';

export default {
    namespaced: true,
    state: {
        contractorOrganisations: [],
        teams: []
    },
    getters: {
        getContractorOrganisations(state){
            return state.contractorOrganisations;
        },
        getTeams(state){
            return state.teams;
        }
    },
    mutations: {
        setContractorOrganisations(state, value){
            state.contractorOrganisations.splice(0, state.contractorOrganisations.length, ...value);
        },
        setTeams(state, value){
            state.teams.splice(0, state.teams.length, ...value);
        }
    },
    actions: {
        async loadContractorOrganisations(context){
            let results = await precedaService.fetchContractorOrganisations();

            context.commit("setContractorOrganisations", results);
        },
        async loadTeams(context){
            let results = await precedaService.fetchTeams();

            context.commit("setTeams", results);
        },
        async downloadContractorExport(context, params){
            await precedaService.downloadContractorExport(
                params.contractorOrganisationID,
                params.startDate,
                params.endDate
            );
        },
        async loadCropWorkPreview(context, params){
            return await precedaService.fetchCropWorkPreview(
                params.contractorOrganisationID,
                params.teamName,
                params.startDate,
                params.endDate
            );
        },
        async downloadCropWorkExport(context, params){
            await precedaService.downloadCropWorkExport(
                params.contractorOrganisationID,
                params.teamName,
                params.startDate,
                params.endDate
            );
        }
    }
}